import React from 'react'
import './index.less'

import { goIndex } from './../../../assets/js/utils'
function SanlianProducts (props) {
    const { data: { position, sublist = [], trackId }, buriedPointEvent } = props
    let { style } = props.data
    if (!style) style = { paddingTop: 0 }
    return (
        <div
            className="sanlianProductsBox"
            style={{ marginTop: `${style.paddingTop / 75}rem` }}
        >
            {sublist.map((item, index) => (
                <div
                    className="sanlianProducts_card"
                    key={item.id}
                    onClick={() => {
                        buriedPointEvent({
                            button_name: `${trackId}-${item.title}`,
                            button_id: `${item.id}`,
                            button_order: `${index + 1}`,
                            area_order: position,
                            button_area: `${position}-${trackId}`
                        })
                        goIndex(item.url, trackId, item.keyword)
                    }}
                >
                    {item.bankName && item.productShortName ? (
                        <React.Fragment>
                            <p className="card_title">{item.bankName}</p>
                            <p className="card_title card_title_sub">
                                {item.productShortName}
                            </p>
                        </React.Fragment>
                    ) : (
                        <p className="card_title">{item.title}</p>
                    )}

                    <p className="card_rate">{item.rate}%</p>
                    <p className="card_rateName">{item.rateName}</p>
                    {item.productMark ? (
                        <span className="card_describe">{item.productMark}</span>
                    ) : null}
                </div>
            ))}
        </div>
    )
}
export default SanlianProducts
